module.exports = __webpack_public_path__ + "img/e5b4e9f.png";